const DT_WISHLIST_FALLBACK_IMAGE =
  'https://cdn.shopify.com/s/files/1/1078/1963/0922/files/logo.jpg?v=1791230201';

class dT_WhistList {
  constructor() {
    this.wishListData = [];
    this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
    this.LOCAL_STORAGE_DELIMITER = ',';
  }

  setListLocalStorageKey(key, delimiter) {
    this.LOCAL_STORAGE_WISHLIST_KEY = key;
    this.LOCAL_STORAGE_DELIMITER = delimiter;
  }

  setupGrid(listType) {
    const wishlist = this.getWishlist();

    const requests = wishlist.map((handle) => {
      const url = '/products/' + handle + '?view=json';
      return this.getProductResponse(url);
    });

    return Promise.all(requests)
      .then((responses) => {
        return responses.map((record) => {
          const fields = record.split('~~');

          return {
            id: fields[0],
            product_title: fields[1],
            product_handle: fields[2],
            product_image: fields[3],
            vendor: fields[4],
            type: fields[5],
            money_price: fields[6],
            price_min: fields[7],
            price_max: fields[8],
            available: fields[9],
            price_varies: fields[10],
            variant_id: fields[11],
            variant_title: fields[12],
            sku: fields[13],
            description: fields[14],
            quantity: '1',
            product_url: '/products/' + fields[2]
          };
        });
      })
      .then(async (records) => {
        records = records.filter(
          (record) =>
            record.product_handle &&
            record.product_handle.trim()
        );

        await Promise.all(
          records.map(async (record) => {
            record.product_handle = record.product_handle.trim();

            const image = (record.product_image || '').trim();

            if (
              image &&
              image !== 'null' &&
              image !== 'undefined'
            ) {
              record.product_image = image;
              return;
            }

            try {
              const root = window.Shopify?.routes?.root || '/';

              const response = await fetch(
                root +
                  'products/' +
                  encodeURIComponent(record.product_handle) +
                  '.js'
              );

              if (!response.ok) {
                throw new Error('Product unavailable');
              }

              const product = await response.json();

              record.product_image =
                product.featured_image ||
                product.images?.[0] ||
                DT_WISHLIST_FALLBACK_IMAGE;
            } catch (error) {
              record.product_image = DT_WISHLIST_FALLBACK_IMAGE;
            }
          })
        );

        this.wishListData = records;
        return records;
      });
  }

  getWishListRecords() {
    return this.wishListData;
  }

  getProductResponse(url) {
    return fetch(url)
      .then((response) => response.text())
      .then((data) => data.replace(/^\s*[\r\n]/gm, ''));
  }

  getTotalCount() {
    return this.getWishlist().length;
  }

  getWishlist() {
    const wishlist = localStorage.getItem(
      this.LOCAL_STORAGE_WISHLIST_KEY
    );

    if (!wishlist) {
      return [];
    }

    return wishlist
      .split(this.LOCAL_STORAGE_DELIMITER)
      .filter(Boolean);
  }

  setWishlist(array) {
    const wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);

    if (array.length) {
      localStorage.setItem(
        this.LOCAL_STORAGE_WISHLIST_KEY,
        wishlist
      );
    } else {
      localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    }

    return wishlist;
  }

  updateWishlist(handle) {
    const wishlist = this.getWishlist();
    const index = wishlist.indexOf(handle);

    if (index === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(index, 1);
    }

    return this.setWishlist(wishlist);
  }

  removeWhishlist(handle) {
    const wishlist = this.getWishlist().filter(
      (item) => item !== handle
    );

    return this.setWishlist(wishlist);
  }

  resetWishlist() {
    return this.setWishlist([]);
  }

  isAddedIntoList(handle) {
    return this.getWishlist().includes(handle);
  }

  remove(arr) {
    const values = Array.prototype.slice.call(arguments, 1);

    values.forEach((value) => {
      let index;

      while ((index = arr.indexOf(value)) !== -1) {
        arr.splice(index, 1);
      }
    });

    return arr;
  }
}

async function getDTProduct(url) {
  try {
    const response = await fetch(url);
    return await response.text();
  } catch (error) {
    console.log(error);
  }
}

class dTXWhishList extends HTMLElement {
  constructor() {
    super();

    this.dTWhistList = new dT_WhistList();
    this.addWishList = this.querySelector('.add-wishlist');

    if (!this.addWishList) {
      return;
    }

    this.productHandle =
      this.addWishList.getAttribute('data-product_handle');

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.addWishList.addEventListener(
      'click',
      this.debouncedOnSubmit
    );

    this.initLoad();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
      window.location =
        document.querySelector('.header__icon--wishlist')?.href ||
        '/pages/favorite';

      return;
    }

    this.addWishList.classList.add('adding');
    this.dTWhistList.updateWishlist(this.productHandle);

    setTimeout(() => this.postAdd(), 1000);
  }

  postAdd() {
    const count = this.dTWhistList.getTotalCount();

    document
      .querySelectorAll(
        '.dtxc-wishlist-count, .mobile-dtxc-wishlist-count'
      )
      .forEach((element) => {
        element.setAttribute('count', count);
      });

    this.addWishList.classList.remove('adding');
    this.addWishList.classList.add('added');
  }

  initLoad() {
    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
      this.addWishList.classList.add('added');
    }
  }
}

customElements.define('dtx-wishlist', dTXWhishList);

class dTXWhishListGrid extends HTMLElement {
  constructor() {
    super();

    this.gridTemplate = this.querySelector('.grid_template');
    this.dtxTable = this.querySelector('.dtx-table');
    this.dtxNoRecord = this.querySelector('.dtx-grid-empty');
    this.grid_type = this.getAttribute('grid_type');
  }

  initLoad() {
    const wishlist = new dT_WhistList();

    wishlist.setupGrid().then((records) => {
      this.generateGrid(records);
    });
  }

  generateGrid(records) {
    if (!this.gridTemplate || !this.dtxTable) {
      return;
    }

    if (
      records.length > 0 &&
      typeof records[0].product_handle !== 'undefined'
    ) {
      records.forEach((record) => {
        const row = this.dtxTable.insertRow(
          this.dtxTable.rows.length
        );

        row.id = 'row_' + record.id;
        row.innerHTML = this.buidRow(record);

        row
          .querySelectorAll('.product-thumbnail img')
          .forEach((image) => {
            const useFallback = () => {
              if (
                image.getAttribute('src') ===
                DT_WISHLIST_FALLBACK_IMAGE
              ) {
                return;
              }

              image.removeAttribute('srcset');
              image.removeAttribute('data-srcset');
              image.removeAttribute('data-src');
              image.src = DT_WISHLIST_FALLBACK_IMAGE;
            };

            image.addEventListener('error', useFallback);

            if (image.complete && image.naturalWidth === 0) {
              useFallback();
            }
          });
      });

      this.dtxNoRecord?.classList.remove('dtx-grid-show');
      this.dtxNoRecord?.classList.add('dtx-grid-hide');

      this.dtxTable.classList.remove('dtx-grid-hide');
      this.dtxTable.classList.add('dtx-grid-show');
    } else {
      this.dtxTable.classList.remove('dtx-grid-show');
      this.dtxTable.classList.add('dtx-grid-hide');

      this.dtxNoRecord?.classList.remove('dtx-grid-hide');
      this.dtxNoRecord?.classList.add('dtx-grid-show');
    }
  }

  buidRow(record) {
    let template = this.gridTemplate.innerHTML;

    const values = {
      product_handle: record.product_handle,
      product_url: record.product_url,
      product_image:
        record.product_image || DT_WISHLIST_FALLBACK_IMAGE,
      product_title: record.product_title,
      money_price: record.money_price,
      variant_id: record.variant_id,
      product_type: record.type || '',
      product_sku: record.sku || '',
      product_vendor: record.vendor || '',
      product_description: record.description || '',
      available:
        record.available === 'true'
          ? window.DT_THEME?.strings?.in_stock || 'În stoc'
          : window.variantStrings?.soldOut || 'Stoc epuizat'
    };

    Object.entries(values).forEach(([key, value]) => {
      const expression = new RegExp(
        '\\{item\\.' + key + '\\}',
        'gi'
      );

      template = template.replace(
        expression,
        () => String(value ?? '')
      );
    });

    return template;
  }

  connectedCallback() {
    this.initLoad();
  }
}

customElements.define('dtx-wishlist-grid', dTXWhishListGrid);

class dTXRemoveWishItem extends HTMLElement {
  constructor() {
    super();

    this.removeItem = this.querySelector('.remove-item');

    if (!this.removeItem) {
      return;
    }

    this.grid_type = this.getAttribute('grid_type');

    this.productHandle =
      this.removeItem.getAttribute('data-product_handle');

    this.debouncedOnSubmit = debounce((event) => {
      this.removeListItem(event);
    }, 500);

    this.removeItem.addEventListener(
      'click',
      this.debouncedOnSubmit
    );
  }

  removeListItem(event) {
    event.preventDefault();

    const wishlist = new dT_WhistList();
    wishlist.removeWhishlist(this.productHandle);

    window.location.reload();
  }
}

customElements.define('dtx-remove-wish-item', dTXRemoveWishItem);

class dTXWishCount extends HTMLElement {
  static get observedAttributes() {
    return ['count'];
  }

  constructor() {
    super();

    this.gridCountBubble =
      this.querySelector('.grid-count-bubble');

    this.grid_type = this.getAttribute('grid_type');
    this.initLoad();
  }

  initLoad() {
  const wishlist = new dT_WhistList();
  const count = Number(wishlist.getTotalCount()) || 0;

  const bubble = this.querySelector('.grid-count-bubble');
  const number = bubble && bubble.querySelector('span');

  if (number) {
    number.textContent = count;
  }

  this.classList.toggle('count-zero', count === 0);
  this.classList.toggle('count-exist', count > 0);

  if (this.getAttribute('count') !== String(count)) {
    this.setAttribute('count', String(count));
  }
}

  attributeChangedCallback() {
    this.initLoad();
  }
}

customElements.define('dtx-wish-count', dTXWishCount);

class MobiledTXWishCount extends HTMLElement {
  static get observedAttributes() {
    return ['count'];
  }

  constructor() {
    super();

    this.gridCountBubble =
      this.querySelector('.grid-count-bubble');

    this.grid_type = this.getAttribute('grid_type');
    this.initLoad();
  }

  initLoad() {
    const wishlist = new dT_WhistList();
    const count = wishlist.getTotalCount();
    const label = this.gridCountBubble?.querySelector('span');

    if (label) {
      label.textContent = count;
    }
  }

  attributeChangedCallback() {
    this.initLoad();
  }
}

customElements.define(
  'mobile-dtx-wish-count',
  MobiledTXWishCount
);

function makeTimer() {
  if (typeof window.jQuery === 'undefined') {
    return;
  }

  window.jQuery('.product-deal-count').each(function () {
    const $ = window.jQuery;
    const endTime =
      Date.parse($(this).attr('data-end-time')) / 1000;

    const now = Date.now() / 1000;
    const timeLeft = endTime - now;

    if (timeLeft > 0) {
      const days = Math.floor(timeLeft / 86400);

      const hours = Math.floor(
        (timeLeft - days * 86400) / 3600
      );

      const minutes = Math.floor(
        (timeLeft - days * 86400 - hours * 3600) / 60
      );

      const seconds = Math.floor(
        timeLeft -
          days * 86400 -
          hours * 3600 -
          minutes * 60
      );

      $(this)
        .find('.days')
        .html(days + '<span>Zile</span>');

      $(this)
        .find('.hours')
        .html(
          String(hours).padStart(2, '0') +
            '<span>Ore</span>'
        );

      $(this)
        .find('.minutes')
        .html(
          String(minutes).padStart(2, '0') +
            '<span>Min</span>'
        );

      $(this)
        .find('.seconds')
        .html(
          String(seconds).padStart(2, '0') +
            '<span>Sec</span>'
        );
    } else {
      $(this).find('.deal-lable').hide();
      $(this).find('.deal-clock').hide();
    }
  });
}

setInterval(makeTimer, 1000);

if (
  typeof Swiper !== 'undefined' &&
  document.querySelector('#swiper-sidebar-carousel')
) {
  var swiper = new Swiper('#swiper-sidebar-carousel', {
    slidesPerView: 1,
    navigation: {
      nextEl: '#swiper-sidebar-next',
      prevEl: '#swiper-sidebar-prev'
    }
  });
}